import React from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import style from './style/index.scss';

/**
 * @param {Object} props - props object
 * @param {'risk_assessment_high'|'risk_assessment_very_high'} props.riskAssessment - risk assessment (either 'risk_assessment_high' or 'risk_assessment_very_high')
 * @param {string} props.handle - scale handle
 * @param {string} props.name - scale name
 * @param {Function} props.onClick - click handler
 *
 * @returns {JSX.Element} - risk card
 */
export function RiskCard(props) {
    const { riskAssessment, handle, name, onClick } = props;

    return (
        <div
            data-scale-handle={handle}
            onClick={onClick}
            className={classNames(style.container, riskAssessment)}
            role='button'
            tabIndex={0}
        >
            {name}
            <div className={style.showScore}>
                <p>
                    <FontAwesomeIcon icon={'chevron-right'} size="sm" />
                </p>
            </div>
        </div>
    );
}
